var persona = {
  PersonaId: null,
  Nombre: null,
  NombreCompleto: null,
  ApellidoPaterno: null,
  ApellidoMaterno: null,
  FechaNacimiento: null,
  FechaRegistro: null,
  CorreoElectronico: null,
  RutaImagenRostro: null,
  
  //Archivo de imagen
  ImagenRostro:null,
  // Ruta de la imagen que devuelve el servidor.
  RutaImagenRostroByte: null,

  // Imagen en base 64 de la firma autógrafa
  ImagenFirmaAutografaBase64: null,

  RutaImagenHuella: null,
  RFC: null,
  CURP: null,
  NSS: null,
  NumeroNomina: null,
  NumeroDeChecador:null,
  Activo: null,
  Puesto: null,
  Departamento: null,
  Seccion: null,
  TipoPlaza: null,
  TipoContrato: null,
  TipoContratoId: null,
  PaisNacimientoId: null,
  TelefonoId: null,
  TipoEstadoCivilId: null,
  SexoId: null,
  DomicilioId: null,
  CuentaBancariaId: null,
  PaisDeNacimientoId: null,
  EntidadDeNacimientoId: null,
  MunicipioDeNacimientoId: null,
  EstructuraOrganicaId: null,
  UsuarioQuienRegistraId: null,
  Domicilio: {
    DomicilioId: null,
    Calle: null,
    CodigoPostal: null,
    NumeroExterno: null,
    NumeroInterno: null,
    FraccColonia: null,
    EntidadesFederativasId: null,
    MunicipiosId: null,
    EntidadFederativa: {
      EntidadFederativaId: -1,
      Nombre: null,
      Codigo: null,
      Activo: null,
      Municipios: null,
      Pais: null
    },
    Municipio: {
      MunicipioId: 0,
      Nombre: null,
      Codigo: null,
      Activo: null,
      EntidadFederativa: null,
      PartidoJudicial: null,
      Areas: []
    }
  },
  EstructuraOrganica: null,
  TipoEstadoCivil: {
    TipoEstadoCivilId: -1,
    Nombre: null
  },
  TipoSexo: {
    TipoSexoId: -1,
    Nombre: null
  },
  Pais: {
    PaisId: 0,
    Nombre: null,
    Codigo: null,
    Activo: null,
    EntidadesFederativas: []
  },
  EntidadFederativa: {
    EntidadFederativaId: -1,
    Nombre: null,
    Codigo: null,
    Activo: null,
    Municipios: null,
    Pais: null
  },
  Municipio: {
    MunicipioId: 0,
    Nombre: null,
    Codigo: null,
    Activo: null,
    EntidadFederativa: null,
    PartidoJudicial: null,
    Areas: []
  },
  Telefonos: [{
      TelefonoId: null,
      PersonaId: null,
      NumeroTelefono: 0,
      TipoTelefonoId: null,
      Activo: null,
      UsuarioIdQuienRegistra_001DBCUENTAS: null,
      FechaRegistro: null,
      TipoTelefono: {
        TipoTelefonoId: -1,
        Nombre: null,
        Activo: null
      }
    },
    {
      TelefonoId: null,
      PersonaId: null,
      NumeroTelefono: 0,
      TipoTelefonoId: null,
      Activo: null,
      UsuarioIdQuienRegistra_001DBCUENTAS: null,
      FechaRegistro: null,
      TipoTelefono: {
        TipoTelefonoId: -1,
        Nombre: null,
        Activo: null
      }
    },
    {
      TelefonoId: null,
      PersonaId: null,
      NumeroTelefono: 0,
      TipoTelefonoId: null,
      Activo: null,
      UsuarioIdQuienRegistra_001DBCUENTAS: null,
      FechaRegistro: null,
      TipoTelefono: {
        TipoTelefonoId: -1,
        Nombre: null,
        Activo: null
      }
    }
  ],
  HistoriaAcademica: [],
  HistorialLaboral: [],
  Superiores: [] ,
  Familiares: [],
  GetNombreCompleto: null
};

var Persona = {
  Persona: persona  
}

export default Persona;



// WEBPACK FOOTER //
// ./src/components/SIAP/Comun/Modelos/Persona.js